// for user Auth
export const RESET_AUTH_USER = "reset_auth_user";
export const AUTH_USER = "auth_user";
export const AUTH_USER_SUCCESS = "auth_user_success";
export const AUTH_USER_FAILURE = "auth_user_failure";
export const SET_PASSWORD_SUCCESS = "set_password_success";
